const InArticlePollingOptions = {
  none: "none",
  allowed: "allowed",
  required: "required",
  meta: "meta",
};
export default InArticlePollingOptions;
